import { BEmbed } from './embed';
import { pluginFactory } from '../../utils/plugins';
var EmbedPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BEmbed: BEmbed
  }
});
export { EmbedPlugin, BEmbed };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/embed/index.js
// module id = ./node_modules/bootstrap-vue/esm/components/embed/index.js
// module chunks = 0 1